/* eslint-disable no-redeclare */
import { Auth, RoleNames } from '@bai/utils/types';

import type { ILocationService, IRootScopeService } from 'angular';

interface AngularUserService {
  updateFromReact?: (auth: Auth) => void;
  clearLocalSessionState?: () => void;
  setUserContext?: (role: RoleNames) => Promise<void>;
}

export enum AngularServiceNames {
  USER_SERVICE = 'UsersService',
  LOCATION = '$location',
  ROOT_SCOPE = '$rootScope',
}

export function getAngularService(
  name: AngularServiceNames.USER_SERVICE,
): AngularUserService;
export function getAngularService(
  name: AngularServiceNames.LOCATION,
): ILocationService;
export function getAngularService(
  name: AngularServiceNames.ROOT_SCOPE,
): IRootScopeService;
export function getAngularService(name: AngularServiceNames): unknown;
export function getAngularService(name: AngularServiceNames): unknown {
  const angular = window.angular.element(document.body);
  if (angular === null) return null;
  return angular.injector()?.get(name);
}
